/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inventory_Metric_Active_CargosInputs */

const en_inventory_metric_active_cargos = /** @type {(inputs: Inventory_Metric_Active_CargosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active Cargos`)
};

const es_inventory_metric_active_cargos = /** @type {(inputs: Inventory_Metric_Active_CargosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargas activas`)
};

/**
* | output |
* | --- |
* | "Active Cargos" |
*
* @param {Inventory_Metric_Active_CargosInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const inventory_metric_active_cargos = /** @type {((inputs?: Inventory_Metric_Active_CargosInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inventory_Metric_Active_CargosInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_inventory_metric_active_cargos(inputs)
	return es_inventory_metric_active_cargos(inputs)
});